export interface SalesContractLineForCreate {
  id: string;
  contractNo: number;
  description: string;
  customerKey: string;
  customerName: string;
  productKey: string;
  productDescription: string;
  unitOfMeasure: string;
  contractLineBalance: number;
  price: number;
  contractLineBalanceValue: number;
  orderQuantity: number;
  selected: boolean;
}
